export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_3WB_19_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_3wb_19_99_usd',
		},
		primer: 'prd_4fcPwA3FstqK',
	},
	otp: {
		priceMap: {
			USD: 19.99,
		},
	},
}
